/**
 * @generated SignedSource<<d1cd6e4e5d0a9f406ca083341ac61cdd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type WeeklyGoalIndicatorQuery$variables = {
  fromDate: any;
  studentId: string;
  toDate: any;
};
export type WeeklyGoalIndicatorQuery$data = {
  readonly studentWeeklyGoalIndicator: ReadonlyArray<{
    readonly code: string;
    readonly name: string;
  }>;
};
export type WeeklyGoalIndicatorQuery = {
  response: WeeklyGoalIndicatorQuery$data;
  variables: WeeklyGoalIndicatorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fromDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "toDate"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "fromDate",
        "variableName": "fromDate"
      },
      {
        "kind": "Variable",
        "name": "studentId",
        "variableName": "studentId"
      },
      {
        "kind": "Variable",
        "name": "toDate",
        "variableName": "toDate"
      }
    ],
    "concreteType": "BaseSkillInfo",
    "kind": "LinkedField",
    "name": "studentWeeklyGoalIndicator",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WeeklyGoalIndicatorQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "WeeklyGoalIndicatorQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "825cfe5b9c87bc9949a610f964f405f7",
    "id": null,
    "metadata": {},
    "name": "WeeklyGoalIndicatorQuery",
    "operationKind": "query",
    "text": "query WeeklyGoalIndicatorQuery(\n  $studentId: ID!\n  $fromDate: DateTime!\n  $toDate: DateTime!\n) {\n  studentWeeklyGoalIndicator(studentId: $studentId, fromDate: $fromDate, toDate: $toDate) {\n    code\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "390976b18f835955c9787c77ac8a7a83";

export default node;
